import { useEffect } from 'react'
import { useState } from 'react';
import { Header } from '../components/Header';
import {
    IMAGE_PATH,
    CLIENT_ID,
    CLIENT_SECRET,
    DATA_DECRYPTION_KEY,
    CDN_ELK_URL,
} from '../components/Constants';
import axios from 'axios';
import crypto from 'crypto-js';
import { decryptAES } from '../components/CryptoUtils';
import { ReusableCarasole } from './ReusableCarasole';
import { ReusableWorkSection } from '../sections/home/ReusableWorkSection';
import { ReusableAbout } from '../sections/home/ReusableAbout';
import { ReusableMobileCard } from './ReusableMobileCard';
import { ReusableFaq } from '../sections/home/ReusableFaq';



export const ReusableRepo = () => {

    const limit = 100;
    const offset = 0;
    const [tasks, setTasks] = useState([]);


    function transformData(inputArray) {

        const fetch_records = inputArray.data.map((record) => ({
            artifact_id: record.artifact_id,
            title: { label: "Title", value: [record["component_title"]] },
            tracker_id: record.tracker_id,
            status: { label: "Status", value: [record.status] },
            short_description: { label: "Short Description", value: [record.short_description] },
            full_description: { label: "Full Description", value: [record.full_description] },
            usage: { label: "Usage", value: [record.usage] },
            code_content: { label: "Code Content", value: [record.code_content || ""] },
            component_added_by: { label: "Added By", value: [record.component_added_by] },
            component_added_date: { label: "Added On", value: [record.component_added_date] },
            technology_used: {
                label: "Technology Used",
                value: record.technology_used.split(',').map(item => item.trim())
            },
            repository_url: { label: "Repository URL", value: [record.git_repository_url] },
            readme: { label: "README", value: [record.readme || ""] },
            timestamp: { label: "Timestamp", value: [record["@timestamp"]] },
        }));

        return {
            fetch_records,
            total_records: inputArray.length,
        };
    }



    // Trigger handleRecords when sortValue changes
    useEffect(() => {
        const handleRecords = async () => {
            try {

                const ts = Math.floor(Date.now() / 1000); // Get the current Unix timestamp

                const hmacStr = CLIENT_SECRET + CLIENT_ID + offset.toString() + limit.toString() + ts.toString();
                const hmacHash = crypto.SHA256(hmacStr).toString(crypto.enc.Hex);
                const advanceFilter = JSON.stringify({ status: ['Active'] });

                const formData = new FormData();
                formData.append('limit', limit);
                formData.append('offset', offset);
                formData.append('order_by', 'desc');
                formData.append('advance_filter', advanceFilter);
                formData.append('client_id', CLIENT_ID);
                formData.append('ts', ts);
                formData.append('hmac', hmacHash);

                //   const result = await axios.post(
                //     `${BASE_URL_API}task/elk_listing`,
                //     formData
                //   );

                const queryParams = {
                    limit: limit,
                    offset: offset,
                    order_by: 'desc',
                    // advance_filter: advanceFilter,
                    client_id: CLIENT_ID,
                    ts: ts,
                    hmac: hmacHash
                };

                const queryString = new URLSearchParams(queryParams).toString();

                const result = await axios.get(`${CDN_ELK_URL}/elk/reusable_components?${queryString}`);

                if (result.data.code === 200) {

                    if (result.data.secure) {
                        const encryptedData = await result.data.data;
                        const decryptedText = await decryptAES(encryptedData, DATA_DECRYPTION_KEY);
                        const flattenData = JSON.parse(decryptedText); // Assuming decrypted data is JSON
                        const output = transformData(flattenData)
                        setTasks(output.fetch_records);
                    } else {

                        setTasks(result.data.data.fetch_records);
                    }

                } else {
                    setTasks([]);

                }
            } catch (error) {
                setTasks([]);
                console.error("There was a problem fetching the tasks:", error);
            }
        };
        handleRecords();

    }, []);


    return (
        <>
            <Header />
            <main style={{ marginTop: '54px' }}>
                <section className="reusable-repo-banner" >
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-7 ">
                                <h1 className="banner-title">Search and Access Reusable  <br />Repository Code </h1>
                                <p className='banner-description'>Empower your team with readily available code. Search, access, <br />and reuse components to build faster and more effectively.</p>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="explor-section" id="explore_1" style={{ backgroundImage: `url(${IMAGE_PATH}/explore_frame.svg)`, backgroundRepeat: 'no-repeat' }}>
                    <div className="container text-left  pt-4 pb-6 pl-0 pr-0">
                        <div className="row mx-auto my-auto justify-content-center">
                            <div className="col-sm-12 mt-4">
                                <div className="d-flex justify-content-between align-items-center mb-2" id="view_all">
                                    <span>
                                        <h1>Explore <span style={{ color: '#00675B' }}> Repositories</span></h1>
                                        <h2 id="work1">Explore the codebase to find and leverage valuable repositories</h2>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="row react-multi-carousel-list">
                            {
                                (tasks.length > 0) ? (tasks.slice(0, 100).map((task, index) => (
                                    <div className="col-12 col-sm-6 col-md-4 col-lg-3 mb-4" key={index}>
                                        <ReusableCarasole task={task} IMAGE_PATH={IMAGE_PATH} />
                                    </div>
                                ))) : ''
                            }
                        </div>
                    </div>
                </section>
                <section className="explor-section" id="explore_2">
                    <div className="container text-left  pt-4">
                        <div className="row mx-auto my-auto justify-content-center">
                            <div className="col-sm-12 mt-4 mb-2">
                                <div className="d-flex justify-content-between align-items-center mb-2" id="view_all">
                                    <span>
                                        <h1>Explore <span style={{ color: "#00675B" }}> Repositories</span></h1>
                                        <h2 id="work1">Explore the codebase to find and leverage valuable repositories</h2>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div id="carouselExampleControls" className="react-multi-carousel-list">
                            {
                                (tasks.length > 0) ? (tasks.slice(0, 100).map((task, index) => (
                                    <ReusableMobileCard
                                        key={index}
                                        task={task}
                                        IMAGE_PATH={IMAGE_PATH} />
                                ))) : ''
                            }
                        </div>
                        <div className="align-items-center mb-4 mt-1" id="view_all_1a">
                        </div>
                    </div>
                </section>
                <ReusableWorkSection />
                <ReusableAbout
                    IMAGE_PATH={IMAGE_PATH}
                />
                <ReusableFaq />
            </main>
        </>
    )
};